export default {
  examDetail_total: '總分',
  examDetail_pass_score: '及格分',
  examDetail_exam_time: '考試時間',
  examDetail_score: "成績",
  examDetail_pass_or_not: "是否通過",
  examDetail_not_yet: '暫無',
  examDetail_in_marking: '閱卷中',
  examDetail_passed: '已通過',
  examDetail_failed: '未通過',
  examDetail_submit_marking_tip: '交卷成功，老師正在閱卷中',
  examDetail_passed_exam_tip: '恭喜你！考試通過啦',
  examDetail_failed_tip: '很遺憾，這次沒有通過，再接再厲吧',
  examDetail_test_again: '再考一次',
  examDetail_check_score: "閱卷完成後，再次進入考試即可查看成績",
  examDetail_check_wrong: "查看錯題",
  examDetail_check_certificate: "查看證書",
  examDetail_my_answers: "我的答案：",
  examDetail_no_answer: '未作答',
  examDetail_correct_answer: "正確答案：",
  examDetail_camera_invigilate: '請允許啟用攝像頭進行監考',
  examDetail_camera_unusual: '攝像頭異常，進入考試失敗',
  examDetail_allow_camera: '請點擊「允許」開啟監考攝像頭',
  examDetail_invigilating: '監考中',
  allow_camera: '點擊開啟攝像頭',
  examDetail_submit_failed: '網絡異常，交卷失敗',
  examDetail_overtime: '已超過考試結束時間10分鐘以外，考試無效',
  examDetail_next_step: '跳轉下一題後將無法再修改本題，確定進入下一題嗎？',
  examDetail_not_prompt_again:"不再提示",
  examDetail_determine: '確定（15s）',
  examDetail_time_limit: '本題限時{nowLimitTime}秒',
  examDetail_unchangeable: '本題已提交，不可修改',
  examDetail_submit_exam_page: "交卷",
  examDetail_previous: '上一題',
  examDetail_next: '下一題',
  examDetail_no_mistake: '暫無錯題',
  examDetail_limitTip: '最多上傳{limit}個附件',
  examDetail_not_allow_special_symbols: '附件題附件不支持文件名含特殊符號',
  examDetail_limit_size: '單個文件不能超過{size}M，請重新選擇',
  examDetail_not_allow_empty: '不能上傳空文件，請重新選擇',
  examDetail_upload_attachment_tip: '請上傳附件完成作答（最多支持上傳三個附件，每個不超過{size}M）',
  examDetail_clean_up: '清空',
  examDetail_revoke: '撤銷',
  examDetail_lineTips: '提示：請從左至右連線，左側可連接多個右側選項',
  examDetail_clearTip: '確定要清空連線嗎',
  examDetail_referAnswer: '參考答案',
  examDetail_enter_answer: '請在此輸入答案',
  examDetail_uploadImageTip: '最多支持上傳9張圖片，格式支持：JPG/PNG/JPEG，每個文件大小不超過5M。',
  examDetail_uploadImage: '上傳圖片',
  examDetail_prompt_tip: "查看提示",
  examDetail_download_exam: '下載附件考題',
  examDetail_tip_info: '提示信息：',
  examDetail_not_supported_audio: '您的瀏覽器暫不支持播放音頻文件',
  examDetail_try_later_audio: '語音轉換還未完成，請稍後嘗試！',
  examDetail_voice_loading: '語音加載中，請稍後嘗試！',
  examDetail_voice_reading: '語音讀題',
  examDetail_history_results: '歷史成績',
  examDetail_open_time: '開放時間：',
  examDetail_format_time: 'YYYY年M月D日 HH:mm',
  examDetail_no_limit_time: '不限時間',
  examDetail_exam_num: '考試次數：',
  examDetail_remainTimes: '您還有{remianingNum}次考試機會',
  examDetail_no_limit_num: '不限考試次數',
  examDetail_exam_careful: '考試註意：',
  examDetail_attentionItem: '開始考試後，請不要關閉瀏覽器或跳出窗口，否則系統將判定考試結束。',
  examDetail_invigilation_mode: '監考模式：',
  examDetail_invigilateItem: '參加考試需要通過身份認證',
  examDetail_exam_marking: '考試閱卷中',
  examDetail_scoreText: "考試{isPassed}通過，獲得最高得分{highestScore}分",
  examDetail_already:"已",
  examDetail_not_yet:"未",
  examDetail_highestScore: '獲得最高得分{highestScore}分',
  examDetail_testNumTxt: '考試數量',
  examDetail_exam_duration: '考試時長',
  examDetail_minute: '分鐘',
  examDetail_unlimited: '不限',
  examDetail_exam_start: '開始考試',
  examDetail_exam_no_start: '考試尚未開始',
  examDetail_exam_end: '考試已結束',
  examDetail_exam_complete: '考試完成',
  examDetail_exam_registration: '考試報名',
  examDetail_exam_again: '再考一次',
  examDetail_under_review: '報名審核中',
  examDetail_info_submited: '報名信息已提交，請等待老師審核',
  examDetail_go_from_app: '暫不支持，請從APP進入',
  examDetail_forbidden_enter:'已達到截屏最大次數，禁止再次進入考試，請聯系管理員解封',
  examDetail_face_recognition:"請先開通人臉識別",
  examDetail_face_recognition_tip:"該考試要求考生開通人臉識別監考，您還未開通人臉識別功能，請先開通",
  examDetail_photograph:'拍照',
  examDetail_remake:'重拍',
  examDetail_uploading:'上傳中',
  examDetail_upload:'上傳',
  examDetail_certification_passed:'認證通過',
  examDetail_info_enter_success:'信息錄入成功',
  examDetail_take_picture:'請面對鏡頭，點擊拍照',
  examDetail_imgUpload:'拍攝完成，請點擊上傳',
  examDetail_being_uploaded_review:'照片正在上傳審核中...',
  examDetail_time_over:'本次考試共{questionNum}題，考試時間到，是否確認交卷',
  examDetail_continue_submit:'繼續交卷（{time}）',
  examDetail_remaining_time:'剩余考試時間：',
  examDetail_exam_total:'本次考試共{total}題',
  examDetail_not_answer:'未答：',
  examDetail_answered:'已答：',
  examDetail_hasNoAnswer:'本次考試共{questionAnswers}題，已答共{yesArr}題，未答共{noArr}題，是否確定交卷？',
  examDetail_all_complete:'本次考試共{questionAnswers}題，你已經全部答完，是否確定交卷？',
  examDetail_go_back_continue:'返回繼續作答',
  examDetail_reference_answer_colon:'參考答案：'
}
